<!-- 中期评审记录表 -->
<template>
  <svg
    t="1748246476452"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="9865"
    width="200"
    height="200"
  >
    <path
      d="M626.761143 324.096l-48.761905-48.761905L609.52381 243.809524l48.761904 48.761905-31.524571 31.524571z m-34.474667 34.474667L438.857143 512h-48.761905v-48.761905l153.429333-153.429333 48.761905 48.761905zM170.666667 73.142857h585.142857l146.285714 146.285714v682.666667a48.761905 48.761905 0 0 1-48.761905 48.761905H170.666667a48.761905 48.761905 0 0 1-48.761905-48.761905V121.904762a48.761905 48.761905 0 0 1 48.761905-48.761905z m536.380952 73.142857v121.904762h121.904762l-121.904762-121.904762zM243.809524 658.285714a24.380952 24.380952 0 0 0 0 48.761905h536.380952a24.380952 24.380952 0 0 0 0-48.761905H243.809524z m0 146.285715a24.380952 24.380952 0 0 0 0 48.761904h536.380952a24.380952 24.380952 0 0 0 0-48.761904H243.809524z m268.190476-219.428572a195.047619 195.047619 0 1 0 0-390.095238 195.047619 195.047619 0 0 0 0 390.095238z"
      fill="#78D750"
      p-id="9866"
    />
  </svg>
</template>
